// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"776":"e8ffee0f726c1275","971":"9a5a92271f230167"}[chunkId] + ".css";
};